import React, { memo } from 'react';
import { FormWrapper } from './Wrappers';
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';

// A single upper-case letter (e.g. a Visma voucher series letter).
export const isLetter = (v: string) => /^[A-ZÅÄÖ]$/.test(v)
const isLetterOrEmpty = (v: string) => v === '' || isLetter(v)

// Input is forced to one upper-case letter as you type. Pass `optional` to also accept an empty
// value (e.g. "use Visma's default series"); otherwise a single letter is required — two baked
// variants, one per validator (the required/optional split is the only difference).
const letterAdapter =
  ({ onChange, ...props }: { onChange: (newValue: string) => void } & Omit<OutlinedInputProps, 'onChange'>) =>
    <OutlinedInput {...props} autoComplete='off' inputProps={{ maxLength: 1 }}
      onChange={(e) => onChange(e.target.value.toUpperCase().slice(0, 1))} />
const RequiredLetterField = FormWrapper({ Component: letterAdapter, validationFunction: isLetter })
const OptionalLetterField = FormWrapper({ Component: letterAdapter, validationFunction: isLetterOrEmpty })

type LetterInputProps = {
  label?: string, value: string, disabled?: boolean, sx?: {}, optional?: boolean,
  onChange: (newValue: string) => void,
}
const LetterInput = memo(({ optional, ...props }: LetterInputProps) =>
  optional ? <OptionalLetterField {...props} /> : <RequiredLetterField {...props} />)

export default LetterInput
